export default __webpack_public_path__ + "static/media/assignment_late.fb88cd60.svg";